import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function PageContent({ children }: Props) {
  return <div style={{ marginTop: '20px' }}>{children}</div>;
}
